import { render, staticRenderFns } from "./PersonalControlsTab.vue?vue&type=template&id=1e87bf3a&scoped=true"
import script from "./PersonalControlsTab.vue?vue&type=script&lang=js"
export * from "./PersonalControlsTab.vue?vue&type=script&lang=js"
import style0 from "./PersonalControlsTab.vue?vue&type=style&index=0&id=1e87bf3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87bf3a",
  null
  
)

export default component.exports